import createMapper from 'map-factory';
import 'reflect-metadata';
import merge from "lodash/merge";
import cloneDeep from "lodash/cloneDeep";
var mapPropertyMetadataKey = Symbol("map-property");
var mapOriginalSetMethodMetadataKey = Symbol("map-set-method");
var mapOriginalGetMethodMetadataKey = Symbol("map-get-method");
var ExtendedMapperMethods;
(function (ExtendedMapperMethods) {
    ExtendedMapperMethods["Get"] = "GET";
    ExtendedMapperMethods["Set"] = "SET";
})(ExtendedMapperMethods || (ExtendedMapperMethods = {}));
var ExtendedMapper = (function () {
    function ExtendedMapper(target, method, options) {
        this.mapper = createMapper(options);
        this.target = target;
        this.method = method;
    }
    ExtendedMapper.prototype.execute = function (data, destination, options) {
        var originalMethod = Reflect.getMetadata((this.method == ExtendedMapperMethods.Get ? mapOriginalGetMethodMetadataKey : mapOriginalSetMethodMetadataKey), this.target);
        var res = null;
        if (this.method === ExtendedMapperMethods.Get) {
            var originalData = originalMethod.call(data);
            res = this.mapper.execute(originalData ? originalData : data, destination);
            if (options && options.merge === true) {
                merge(res, originalData);
            }
        }
        else {
            res = this.mapper.execute(data, destination);
            originalMethod.call(res, data);
        }
        return res;
    };
    return ExtendedMapper;
}());
function createExtendedMapper(target, method, options) {
    var extendedMapper = new ExtendedMapper(target, method, options);
    return extendedMapper;
}
export function MapProperty(options) {
    return function (target, propertyKey) {
        var propertyList = Reflect.getMetadata(mapPropertyMetadataKey, target);
        if (!propertyList)
            propertyList = [];
        propertyList.push({
            options: options,
            target: target,
            propertyKey: propertyKey,
        });
        Reflect.defineMetadata(mapPropertyMetadataKey, propertyList, target);
    };
}
export function MapSetMethod(options) {
    return function (target, propertyKey, descriptor) {
        var propertyList = Reflect.getMetadata(mapPropertyMetadataKey, target);
        var originalMethod = descriptor.value;
        Reflect.defineMetadata(mapOriginalSetMethodMetadataKey, originalMethod, target);
        var mainMapper = createSetMapper(propertyList, target);
        descriptor.value = function (object) {
            mainMapper.execute(object, this, options);
        };
        return descriptor;
    };
}
function createSetMapper(propertyList, target) {
    var extendedMapper = createExtendedMapper(target, ExtendedMapperMethods.Set);
    if (!propertyList)
        return extendedMapper;
    propertyList.forEach(function (prop) {
        var childType = prop.options.type;
        var childTarget = childType ? childType.prototype : null;
        var childPropertyList = childTarget ? Reflect.getMetadata(mapPropertyMetadataKey, childTarget) : null;
        if (childTarget != target && childPropertyList) {
            var childMapper_1 = createSetMapper(childPropertyList, childTarget);
            if (prop.type === Array || prop.options.isArray) {
                extendedMapper.mapper.map(prop.options.from).to(prop.propertyKey, function (items) {
                    var a = [];
                    items.forEach(function (item) {
                        a.push(childMapper_1.execute(item, new childType()));
                    });
                    return a;
                });
            }
            else {
                extendedMapper.mapper.map(prop.options.from).to(prop.propertyKey, function (item) {
                    return childMapper_1.execute(item, new childType());
                });
            }
        }
        else {
            extendedMapper.mapper.map(prop.options.from).to(prop.propertyKey);
        }
    });
    return extendedMapper;
}
export function MapGetMethod(options) {
    return function (target, propertyKey, descriptor) {
        var propertyList = Reflect.getMetadata(mapPropertyMetadataKey, target);
        var originalMethod = descriptor.value;
        Reflect.defineMetadata(mapOriginalGetMethodMetadataKey, originalMethod, target);
        var mainMapper = createGetMapper(propertyList, target);
        descriptor.value = function (mapGetMethodParameter) {
            var tags = mapGetMethodParameter ? mapGetMethodParameter.tags : undefined;
            console.log('getData res', this, target, this === target, mapGetMethodParameter, propertyList);
            if (!Array.isArray(tags) || tags.length <= 0)
                return mainMapper.execute(this, null, options);
            if (!propertyList) {
                return mainMapper.execute(this, null, options);
            }
            else {
                var data_1 = cloneDeep(this);
                propertyList.forEach(function (prop) {
                    var propTags = prop.options.tags;
                    var keepProperty = false;
                    if (Array.isArray(propTags) && propTags.length > 0) {
                        keepProperty = propTags.some(function (propTag) {
                            return tags.indexOf(propTag) >= 0;
                        });
                    }
                    if (!keepProperty)
                        delete data_1[prop.propertyKey];
                });
                return mainMapper.execute(data_1, null, options);
            }
        };
        return descriptor;
    };
}
function createGetMapper(propertyList, target) {
    var extendedMapper = createExtendedMapper(target, ExtendedMapperMethods.Get);
    if (!propertyList)
        return extendedMapper;
    propertyList.forEach(function (prop) {
        var childType = prop.options.type ? prop.options.type : prop.type;
        var childTarget = childType ? childType.prototype : null;
        var childPropertyList = childTarget ? Reflect.getMetadata(mapPropertyMetadataKey, childTarget) : null;
        var targetProperty = prop.options.to ? prop.options.to : prop.options.from;
        if (childTarget != target && childPropertyList) {
            var childMapper_2 = createGetMapper(childPropertyList, childTarget);
            if (prop.type === Array || prop.options.isArray) {
                extendedMapper.mapper.map(prop.propertyKey).to(targetProperty, function (items) {
                    var a = [];
                    items.forEach(function (item) {
                        a.push(childMapper_2.execute(item));
                    });
                    return a;
                });
            }
            else {
                extendedMapper.mapper.map(prop.propertyKey).to(targetProperty, function (item) {
                    return childMapper_2.execute(item);
                });
            }
        }
        else {
            extendedMapper.mapper.map(prop.propertyKey).to(targetProperty);
        }
    });
    return extendedMapper;
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/mapper/ClassMapper.ts
// module id = OBkS
// module chunks = 10